export default __webpack_public_path__ + "images/building2.jpg";